import { useState } from "react";

// ui
import {
  Button,
  Typography,
  Modal,
  Box,
  Paper,
  Alert,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Checkbox,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

// jotai
import { useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";

interface GetXLSXConfirmPaymentModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  getXLSXStatus: {
    status: "none" | "open" | "getting" | "result" | "loading" | "error";
    message: string;
    sale_company_id: number | null;
    sale_company_name: string;
    payment_year: string;
    payment_month: string;
  };
  setGetXLSXStatus: (getXLSXStatus: {
    status: "none" | "open" | "getting" | "result" | "loading" | "error";
    message: string;
    sale_company_id: number | null;
    sale_company_name: string;
    payment_year: string;
    payment_month: string;
  }) => void;
  getXLSXFunc: () => void;
  firstYear: number;
  thisYear: number;
  thisMonth: number;
  companyList: { id: number; sale_company_name: string }[];
}

export function GetXLSXConfirmPaymentModal(
  props: GetXLSXConfirmPaymentModalProps
) {
  const {
    onModal,
    swCloseModal,
    getXLSXStatus,
    setGetXLSXStatus,
    getXLSXFunc,
    firstYear,
    thisYear,
    thisMonth,
    companyList,
  } = props;

  const loginUser = useAtomValue(AppAtoms.loginUser);

  const createDayList = () => {
    let dayList = [];
    for (let i = 20; i <= 31; i++) {
      dayList.push(i.toString());
    }
    return dayList;
  };
  const createMonthList = () => {
    let monthList = [];
    for (let i = 1; i <= 12; i++) {
      monthList.push(i.toString());
    }
    return monthList;
  };
  const createYearList = () => {
    let yearList = [];
    for (let i = firstYear; i <= thisYear; i++) {
      yearList.push(i.toString());
    }
    return yearList;
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  return (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          明細ダウンロード
        </Typography>
        {getXLSXStatus.status === "open" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
            <Paper elevation={1}>
              <Box sx={{ maxHeight: "calc(70vh - 80px)", overflowY: "auto" }}>
                <Box key={"paymentElsxAlert"} sx={{ margin: "0px 0px" }}>
                  <Alert severity="info">
                    <Box>管理者が発行した明細のみダウンロード可能です。</Box>
                  </Alert>
                </Box>
                <Box key={"paymentElsxBoxYear"} sx={{ margin: "30px 0px" }}>
                  <FormControl
                    sx={{
                      marginLeft: "30px",
                      marginTop: "10px",
                      width: "350px",
                    }}
                  >
                    明細年月
                  </FormControl>
                  <FormControl sx={{ width: "200px" }}>
                    <InputLabel id="serch-input-label">年</InputLabel>
                    <Select
                      labelId="serch-input-label"
                      id="serch-input"
                      value={getXLSXStatus.payment_year}
                      label={"年"}
                      onChange={(e) =>
                        setGetXLSXStatus({
                          ...getXLSXStatus,
                          payment_year: e.target.value,
                        })
                      }
                      sx={{
                        height: "30px",
                        textAlign: "end",
                      }}
                    >
                      {createYearList().map((input, i) => {
                        return (
                          <MenuItem
                            key={"input" + i}
                            value={input}
                            sx={{ textAlign: "right" }}
                          >
                            {input}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <FormControl sx={{ width: "150px", marginLeft: "30px" }}>
                    <InputLabel id="serch-input-label">月</InputLabel>
                    <Select
                      labelId="serch-input-label"
                      id="serch-input"
                      value={getXLSXStatus.payment_month}
                      label={"月"}
                      onChange={(e) =>
                        setGetXLSXStatus({
                          ...getXLSXStatus,
                          payment_month: e.target.value,
                        })
                      }
                      sx={{
                        height: "30px",
                        textAlign: "end",
                      }}
                    >
                      {createMonthList().map((input, i) => {
                        return (
                          <MenuItem
                            key={"input" + i}
                            value={input}
                            sx={{ textAlign: "right" }}
                          >
                            {input}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Box>

                {loginUser?.authority !== "パートナー" ? (
                  <Box
                    key={"paymentElsxSaleCompany"}
                    sx={{ margin: "30px 0px" }}
                  >
                    <FormControl
                      sx={{
                        marginLeft: "30px",
                        marginTop: "10px",
                        width: "350px",
                      }}
                    >
                      パートナー
                    </FormControl>
                    <FormControl sx={{ width: "380px" }}>
                      <Select
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.sale_company_id}
                        onChange={async (e) => {
                          const sale_company_id = e.target.value as number;
                          let sale_company_name = "";
                          companyList.map((company, i) => {
                            if (company.id === sale_company_id) {
                              sale_company_name = company.sale_company_name;
                            }
                          });
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            sale_company_id,
                            sale_company_name,
                          });
                        }}
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {companyList.map((company, i) => {
                          return (
                            <MenuItem
                              key={"company" + i}
                              value={company.id}
                              sx={{ textAlign: "right" }}
                            >
                              {company.sale_company_name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Box>
                ) : null}
              </Box>
            </Paper>
            <Box>
              <Button
                disabled={
                  loginUser?.authority !== "パートナー" &&
                  getXLSXStatus.sale_company_id === null
                }
                variant="outlined"
                style={{
                  marginTop: "15px",
                  height: "40px",
                  position: "absolute",
                  right: "205px",
                  width: "250px",
                  fontSize: "20px",
                }}
                onClick={() => {
                  getXLSXFunc();
                }}
              >
                <Box className="m-plus-rounded-1c-modal">ダウンロード</Box>
                <FileDownloadIcon
                  sx={{ marginLeft: "6px" }}
                  fontSize="medium"
                />
              </Button>
              <Button
                variant="outlined"
                style={{
                  marginTop: "15px",
                  height: "40px",
                  position: "absolute",
                  right: "35px",
                  width: "160px",
                  fontSize: "20px",
                }}
                onClick={swCloseModal}
              >
                <Box className="m-plus-rounded-1c-modal">キャンセル</Box>
              </Button>
            </Box>
          </Typography>
        ) : getXLSXStatus.status === "loading" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
            <Box sx={{ textAlign: "center" }}>明細取得中</Box>
          </Typography>
        ) : getXLSXStatus.status === "getting" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
            <Box sx={{ textAlign: "center" }}>{getXLSXStatus.message}</Box>
          </Typography>
        ) : getXLSXStatus.status === "error" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
            <Alert severity="error">
              <Box>明細のダウンロードに失敗しました。</Box>
              <Box>明細が発行されていません。</Box>
            </Alert>
            <Button
              variant="outlined"
              style={{
                marginTop: "15px",
                height: "40px",
                position: "absolute",
                right: "45px",
                width: "160px",
                fontSize: "20px",
              }}
              onClick={() =>
                setGetXLSXStatus({
                  status: "open",
                  message: "",
                  sale_company_id: null,
                  sale_company_name: "",
                  payment_year: thisYear.toString(),
                  payment_month: thisMonth.toString(),
                })
              }
            >
              戻る
            </Button>
          </Typography>
        ) : getXLSXStatus.status === "result" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
            <Box>{getXLSXStatus.message}</Box>
            <Button
              variant="outlined"
              style={{
                marginTop: "15px",
                height: "40px",
                position: "absolute",
                right: "45px",
                width: "160px",
                fontSize: "20px",
              }}
              onClick={swCloseModal}
            >
              閉じる
            </Button>
          </Typography>
        ) : null}
      </Box>
    </Modal>
  );
}
